import React from 'react'
import clsx from 'clsx'

import { Badge } from '@wartek-id/badge'
import { Icon } from '@wartek-id/icon'
import { Sheet, SheetContent, SheetOverlay } from '@wartek-id/sheet-v1'
import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'

import FaseList from './components/FaseList'

import type { TFase, TFaseGroup } from 'types/classAndPhases'

interface FaseSheetProps {
  close: () => void
  isOpen: boolean
  setSelectedFase: (fase: TFase) => void
  selectedFase: TFase
  selectedFaseGroup: TFaseGroup
  setSelectedFaseGroup: (faseGroup: TFaseGroup) => void
}

const faseGroups: TFaseGroup[] = ['Umum', 'SMK', 'SLB']

const FaseSheet = ({
  close,
  isOpen,
  selectedFase,
  setSelectedFase,
  selectedFaseGroup,
  setSelectedFaseGroup,
}: FaseSheetProps) => {
  const [activeFaseGroup, setActiveFaseGroup] = React.useState<TFaseGroup>(
    selectedFaseGroup || null
  )
  const [tempFase, setTempFase] = React.useState<TFase>(null)

  const chooseFase = () => {
    setSelectedFase(tempFase)
    setSelectedFaseGroup(activeFaseGroup)
    close()
  }

  React.useEffect(() => {
    setActiveFaseGroup(selectedFaseGroup)
    setTempFase(selectedFase)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <Sheet isOpen={isOpen} onClose={close} position="bottom" sheetSize="full">
      <SheetOverlay />

      <SheetContent className="max-w-xl m-auto !rounded-none">
        <div className="flex items-center p-5 w-full shadow-md mb-4">
          <Icon onClick={close}>close</Icon>
          <Text variant="heading-sm" className="ml-6">
            Pilih Fase
          </Text>
        </div>
        <main className="h-full w-full px-4">
          <section className="sticky flex gap-x-2 bg-white">
            {faseGroups?.map((faseGroup: TFaseGroup) => (
              <Badge
                key={faseGroup}
                className={clsx(
                  'inline-block cursor-pointer border !py-2 !px-3',
                  activeFaseGroup === faseGroup
                    ? '!border-interactive-default !bg-surface-informational-subdued !text-interactive-default'
                    : 'text-default !border-[#808489]'
                )}
                onClick={() => {
                  setActiveFaseGroup(faseGroup)
                  setTempFase(null)
                }}
              >
                {faseGroup}
              </Badge>
            ))}
          </section>

          {activeFaseGroup && (
            <FaseList
              activeFaseGroup={activeFaseGroup}
              selectedFase={tempFase}
              setSelectedFase={setTempFase}
            />
          )}
          {tempFase && (
            <div className="fixed bottom-0 left-0 h-[80px] w-full max-w-xl border-t border-disabled bg-white p-4">
              <Button
                fullWidth
                color="blue"
                className="!h-full"
                onClick={chooseFase}
              >
                Pilih
              </Button>
            </div>
          )}
        </main>
      </SheetContent>
    </Sheet>
  )
}

export default FaseSheet
